<template>
  <div id="app" v-if="!inLocalIframe">
    <toolbar ref="toolbar"></toolbar>
      <router-view :class="{'shiftAppUp neweng-print-bg': isShifted}"></router-view>
    <open-in-app @isVisible="seenOpenInApp = true" v-if="!$isEngCom"></open-in-app>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import app from './mixins'

export default {
  name: 'app',
  mixins: [app],
  computed: {
    isShifted: function () {
      return !this.seenOpenInApp && this.$route.name !== 'messaging' && this.$route.name !== 'publicMessaging' && this.$route.name !== 'about' && this.$route.name !== 'moving'
    }
  },
  mounted: function () {
    this.initCallbacks()
  }
}
</script>

<style lang="scss">
  @import "./style.scss";
  @import "./newEngStyles.scss";
</style>
